// #region EXECUTION columns definitions
import { TranslateService } from '@ngx-translate/core';
import { EstensaColDef } from '../search-param.model';
import { BoolIconRendererIconType } from '../search-result/cell-renderers/bool-icon-renderer/bool-icon-renderer.component';
import { ApExamination } from '@se/models';
import { GridUtilitiesService } from '../../services/grid-utilities.service';

//le icone soggette a setting sono nascoste, gli altri sono commentati per non ritrovarli nel menu di configurazione
export function executionColumnDefs(translate: TranslateService, gridUtils: GridUtilitiesService): EstensaColDef[] {
    return [
        {
            colId: 'FeaAuthHead',
            headerName: '',
            valueGetter: (e) => e.data,
            minWidth: 25,
            maxWidth: 50,
            tooltipField: translate.instant('FeaAuthHead'),
            cellRendererParams: {
                estensa(data: ApExamination) {
                    if (data.feaData != null && data.feaData.hasPatientAuthorization) {
                        return {
                            iconType: BoolIconRendererIconType.AngularMaterial,
                            icon: 'check',
                            fontSize: '20px',
                            color: 'green',
                            tooltip: translate.instant('FeaAuthHead'),
                        };
                    }
                },
            },
            sortable: false,
            estensaDetails: {
                primary: false,
            },
            hide: true,
        },
        {
            colId: 'FeaExamConsentHead',
            headerName: '',
            valueGetter: (e) => e.data,
            minWidth: 25,
            maxWidth: 50,
            tooltipField: translate.instant('FeaExamConsentHead'),
            cellRendererParams: {
                estensa(data: ApExamination) {
                    if (
                        data.feaData != null &&
                        data.feaData.hasPatientAuthorization &&
                        !data.feaData.isConsentValidated
                    ) {
                        return {
                            iconType: BoolIconRendererIconType.AngularMaterial,
                            icon: 'check',
                            fontSize: '20px',
                            color: 'yellow',
                            tooltip: translate.instant('FeaExamConsentHead'),
                        };
                    }
                    if (
                        data.feaData != null &&
                        data.feaData.hasPatientAuthorization &&
                        data.feaData.isConsentValidated
                    ) {
                        return {
                            iconType: BoolIconRendererIconType.AngularMaterial,
                            icon: 'check',
                            fontSize: '20px',
                            color: 'green',
                            tooltip: translate.instant('FeaExamConsentHead'),
                        };
                    }
                },
            },
            sortable: false,
            estensaDetails: {
                primary: false,
            },
            hide: true,
        },
        {
            colId: 'SendToWorklist',
            headerName: '',
            valueGetter: (e) => e.data,
            minWidth: 25,
            maxWidth: 50,
            cellStyle: { display: 'flex', justifyContent: 'center' },
            cellRenderer: 'stateIconRenderer',
            cellRendererParams: {
                estensa(data: ApExamination) {
                    if (data.command.mustBeManualSentToWorklist === true) {
                        return {
                            iconType: BoolIconRendererIconType.AngularMaterial,
                            icon: 'screen_share',
                            fontSize: '20px',
                            tooltip: translate.instant('SendToWorklist'),
                        };
                    }
                },
            },
            tooltipField: translate.instant('SendToWorklist'),
            sortable: false,
            estensaDetails: {
                primary: false,
            },
            hide: false,
        },
        {
            colId: 'Doses',
            headerName: '',
            headerTooltip: translate.instant('Doses'),
            valueGetter: (e) => e.data,
            minWidth: 25,
            maxWidth: 50,
            headerComponentParams: {
                template:
                    '<div><img src="assets/images/menu/RadioTherapy.png" style="height:18px;width:18px;"> </img></div>',
            },
            cellRenderer: (params: ApExamination) =>
                params.hasDose
                    ? '<div><img src="assets/images/menu/RadioTherapy.png" style="height:18px;width:18px;"> </img></div>'
                    : '<div></div>',
            sortable: false,
            estensaDetails: {
                primary: false,
            },
            hide: true,
        },
        {
            colId: '0',
            headerName: translate.instant('BookingDate'),
            headerTooltip: translate.instant('BookingDate'),
            field: 'plannedDate',
            maxWidth: 200,
            width: 170,
            minWidth: 150,
            valueFormatter: gridUtils.dateTimeFormatter('plannedDate'),
            comparator: gridUtils.dateComparator,
            suppressSizeToFit: false,
            tooltipValueGetter: (p) => p.valueFormatted,
            estensaDetails: {
                primary: false,
                valueFormatter: gridUtils.dateTimeFormatter('plannedDate'),
            },
            hide: false,
        },

        {
            colId: '1',
            headerName: translate.instant('AdmissionDate'),
            headerTooltip: translate.instant('AdmissionDate'),
            field: 'admissionDate',
            maxWidth: 200,
            width: 170,
            minWidth: 150,
            sort: 'asc',
            valueFormatter: gridUtils.dateTimeFormatter('admissionDate'),
            comparator: gridUtils.dateComparator,
            suppressSizeToFit: false,
            tooltipValueGetter: (p) => p.valueFormatted,
            estensaDetails: {
                primary: true,
                valueFormatter: gridUtils.dateTimeFormatter('admissionDate'),
            },
            hide: false,
        },
        {
            colId: '2',
            headerName: translate.instant('ExamDate'),
            headerTooltip: translate.instant('ExamDate'),
            tooltipValueGetter: (p) => p.valueFormatted,
            field: 'executionDate',
            maxWidth: 200,
            width: 170,
            minWidth: 150,
            valueFormatter: gridUtils.dateTimeFormatter('executionDate'),
            comparator: gridUtils.dateComparator,
            estensaDetails: {
                primary: false,
                valueFormatter: gridUtils.dateTimeFormatter('executionDate'),
            },
            hide: false,
        },
        {
            colId: '3',
            headerName: translate.instant('Patient'),
            headerTooltip: translate.instant('Patient'),
            valueGetter: (e) =>
                `${e.data.patient.surname.toLocaleUpperCase()} ${e.data.patient.name.toLocaleUpperCase()}`,
            tooltipValueGetter: (e) =>
                `${e.data.patient.surname.toLocaleUpperCase()} ${e.data.patient.name.toLocaleUpperCase()}`,
            width: 220,
            minWidth: 190,
            suppressSizeToFit: true,
            estensaDetails: {
                primary: true,
                valueGetter: (data) =>
                    `${data.patient.surname.toLocaleUpperCase()} ${data.patient.name.toLocaleUpperCase()}`,
            },
            hide: false,
        },
        {
            colId: '4',
            headerName: translate.instant('BirthDate'),
            headerTooltip: translate.instant('BirthDate'),
            tooltipValueGetter: (p) => p.valueFormatted,
            field: 'patient.birthDate',
            maxWidth: 200,
            width: 150,
            minWidth: 120,
            valueFormatter: gridUtils.dateFormatter(['patient', 'birthDate']),
            comparator: gridUtils.dateComparator,
            estensaDetails: {
                primary: true,
                valueFormatter: gridUtils.dateFormatter(['patient', 'birthDate']),
            },
            hide: false,
        },
        {
            colId: '5',
            headerName: translate.instant('TaxCode'),
            headerTooltip: translate.instant('TaxCode'),
            tooltipField: 'patient.taxCode',
            field: 'patient.taxCode',
            maxWidth: 200,
            width: 150,
            minWidth: 120,
            suppressSizeToFit: false,
            estensaDetails: {
                primary: false,
            },
            hide: false,
        },
        {
            colId: '6',
            headerName: translate.instant('PatientIdentifier'),
            headerTooltip: translate.instant('PatientIdentifier'),
            tooltipField: 'patient.patientId',
            field: 'patient.patientId',
            maxWidth: 200,
            width: 150,
            minWidth: 120,
            suppressSizeToFit: false,
            estensaDetails: {
                primary: false,
            },
            hide: false,
        },
        {
            colId: '7',
            headerName: translate.instant('CARDIO_Identifier'),
            headerTooltip: translate.instant('CARDIO_Identifier'),
            tooltipField: '',
            field: '',
            maxWidth: 200,
            width: 150,
            minWidth: 120,
            suppressSizeToFit: false,
            estensaDetails: {
                primary: false,
            },
            hide: false,
        },
        {
            colId: '8',
            headerName: translate.instant('Exam'),
            headerTooltip: translate.instant('Exam'),
            field: 'exam.description',
            maxWidth: 250,
            width: 200,
            minWidth: 150,
            suppressSizeToFit: false,
            estensaDetails: {
                primary: true,
            },
            hide: false,
        },
        {
            colId: '9',
            headerName: translate.instant('Status'),
            headerTooltip: translate.instant('Status'),
            tooltipField: 'status',
            field: 'status',
            maxWidth: 200,
            width: 120,
            minWidth: 100,
            suppressSizeToFit: false,
            estensaDetails: {
                primary: true,
            },
            hide: false,
        },
        {
            colId: '10',
            headerName: translate.instant('Severity'),
            headerTooltip: translate.instant('Severity'),
            tooltipField: 'severity.description',
            field: 'severity.description',
            maxWidth: 200,
            width: 150,
            minWidth: 120,
            suppressSizeToFit: false,
            estensaDetails: {
                primary: true,
            },
            hide: false,
        },
        //{
        //    colId: '11',
        //    headerName: translate.instant('AiScore'),
        //    headerTooltip: translate.instant('AiScore'),
        //    tooltipField: 'aiData.scoreValue',
        //    field: 'aiData.scoreValue',
        //    maxWidth: 200,
        //    width: 120,
        //    minWidth: 100,
        //    suppressSizeToFit: false,
        //    estensaDetails: {
        //        primary: false
        //    },
        //    hide: true
        //},
        {
            colId: '12',
            headerName: translate.instant('Provenance'),
            headerTooltip: translate.instant('Provenance'),
            tooltipField: 'provenance.description',
            field: 'provenance.description',
            width: 200,
            minWidth: 150,
            maxWidth: 250,
            suppressSizeToFit: false,
            estensaDetails: {
                primary: true,
            },
            hide: false,
        },
        {
            colId: '13',
            headerName: translate.instant('PatientState'),
            headerTooltip: translate.instant('PatientState'),
            tooltipField: 'patientStatus.description',
            field: 'patientStatus.description',
            maxWidth: 200,
            width: 120,
            minWidth: 100,
            suppressSizeToFit: false,
            estensaDetails: {
                primary: false,
            },
            hide: false,
        },

        {
            colId: '14',
            headerName: translate.instant('Equipment'),
            headerTooltip: translate.instant('Equipment'),
            tooltipField: 'equipment.description',
            field: 'equipment.description',
            maxWidth: 200,
            width: 170,
            minWidth: 150,
            suppressSizeToFit: false,
            estensaDetails: {
                primary: false,
            },
            hide: false,
        },

        {
            colId: '15',
            headerName: translate.instant('Room'),
            headerTooltip: translate.instant('Room'),
            tooltipField: 'room.description',
            field: 'room.description',
            maxWidth: 200,
            width: 170,
            minWidth: 150,
            estensaDetails: {
                primary: false,
            },
            hide: false,
        },
        {
            colId: '16',
            headerName: translate.instant('BusinessUnit'),
            headerTooltip: translate.instant('BusinessUnit'),
            tooltipField: 'businessUnit.description',
            field: 'businessUnit.description',
            maxWidth: 200,
            width: 170,
            minWidth: 150,
            suppressSizeToFit: false,
            estensaDetails: {
                primary: false,
            },
            hide: false,
        },

        {
            colId: 'TicketOkHead',
            headerName: '',
            headerTooltip: translate.instant('TicketOk'),
            valueGetter: (e) => e.data,
            cellStyle: { display: 'flex', justifyContent: 'center' },
            cellRenderer: 'stateIconRenderer',
            cellRendererParams: {
                estensa(data: ApExamination) {
                    if (data.ticket === true) {
                        return {
                            iconType: BoolIconRendererIconType.AngularMaterial,
                            icon: 'check',
                            fontSize: '20px',
                            color: 'green',
                            tooltip: translate.instant('TicketOk'),
                        };
                    }
                    if (data.ticket === false) {
                        return {
                            iconType: BoolIconRendererIconType.AngularMaterial,
                            icon: 'check',
                            fontSize: '20px',
                            color: 'red',
                            tooltip: translate.instant('TicketNonEsente/NonPagato'),
                        };
                    }
                },
            },
            minWidth: 25,
            maxWidth: 50,
            estensaDetails: {
                primary: false,
            },
            hide: false,
        },
        {
            colId: '17',
            headerName: translate.instant('AccessionNumber'),
            headerTooltip: translate.instant('AccessionNumber'),
            tooltipField: 'accessionNumber',
            field: 'accessionNumber',
            maxWidth: 200,
            width: 120,
            minWidth: 100,
            estensaDetails: {
                primary: false,
            },
            hide: false,
        },
        {
            colId: '18',
            headerName: translate.instant('AdmissionNumber'),
            headerTooltip: translate.instant('AdmissionNumber'),
            tooltipField: 'admissionNumber',
            field: 'admissionNumber',
            maxWidth: 200,
            width: 120,
            minWidth: 100,
            estensaDetails: {
                primary: false,
            },
            hide: true,
        },
        {
            colId: '19',
            headerName: translate.instant('ExternalAdmissionNumber'),
            headerTooltip: translate.instant('ExternalAdmissionNumber'),
            tooltipField: 'externalNumber',
            field: 'externalNumber',
            maxWidth: 200,
            width: 120,
            minWidth: 100,
            estensaDetails: {
                primary: false,
            },
            hide: false,
        },
        {
            colId: '20',
            headerName: translate.instant('FolderNumber'),
            headerTooltip: translate.instant('FolderNumber'),
            tooltipField: 'folderNumber',
            field: 'folderNumber',
            maxWidth: 200,
            width: 120,
            minWidth: 100,
            estensaDetails: {
                primary: false,
            },
            hide: false,
        },
        {
            colId: '21',
            headerName: translate.instant('HospitalizationNumberShort'),
            headerTooltip: translate.instant('HospitalizationNumberShort'),
            tooltipField: 'hospitalizationNumber',
            field: 'hospitalizationNumber',
            maxWidth: 200,
            minWidth: 170,
            estensaDetails: {
                primary: false,
            },
            hide: false,
        },
        {
            colId: '22',
            headerName: translate.instant('BraceletNumber'),
            headerTooltip: translate.instant('BraceletNumber'),
            tooltipField: '',
            field: '',
            maxWidth: 200,
            width: 120,
            minWidth: 100,
            estensaDetails: {
                primary: false,
            },
            hide: false,
        },
        {
            colId: '23',
            headerName: translate.instant('ReportDate'),
            headerTooltip: translate.instant('ReportDate'),
            tooltipValueGetter: (p) => p.valueFormatted,
            tooltipField: 'reportDate',
            valueFormatter: gridUtils.dateTimeFormatter('reportDate'),
            comparator: gridUtils.dateComparator,
            field: 'reportDate',
            maxWidth: 200,
            width: 120,
            minWidth: 100,
            suppressSizeToFit: false,
            estensaDetails: {
                primary: false,
                valueFormatter: gridUtils.dateTimeFormatter('report.date'),
            },
            hide: false,
        },
        {
            colId: '24',
            headerName: translate.instant('ReferringPhysician'),
            headerTooltip: translate.instant('ReferringPhysician'),
            tooltipField: 'referringPhysician.fullName',
            field: 'referringPhysician.fullName',
            maxWidth: 200,
            width: 170,
            minWidth: 150,
            suppressSizeToFit: false,
            estensaDetails: {
                primary: false,
            },
            hide: false,
        },
        {
            colId: '25',
            headerName: translate.instant('AiStatus'),
            headerTooltip: translate.instant('AiStatus'),
            tooltipField: 'aiData.status',
            field: 'aiData.status',
            maxWidth: 200,
            width: 120,
            minWidth: 100,
            suppressSizeToFit: false,
            estensaDetails: {
                primary: false,
            },
            hide: false,
        },
        {
            colId: '26',
            headerName: translate.instant('AiClinicalApp'),
            headerTooltip: translate.instant('AiClinicalApp'),
            tooltipField: 'aiData.clinicalApp',
            field: 'aiData.clinicalApp',
            maxWidth: 200,
            width: 120,
            minWidth: 100,
            suppressSizeToFit: false,
            estensaDetails: {
                primary: false,
            },
            hide: false,
        },
    ];
}

export function primaryExecutionColumnDef(
    translate: TranslateService,
    gridUtils: GridUtilitiesService,
): EstensaColDef[] {
    let colDef = executionColumnDefs(translate, gridUtils);
    return colDef.filter((col) => col.estensaDetails?.primary === true);
}

export function secondaryExecutionColumnDef(
    translate: TranslateService,
    gridUtils: GridUtilitiesService,
): EstensaColDef[] {
    let colDef = executionColumnDefs(translate, gridUtils);
    return colDef.filter((col) => col.estensaDetails?.primary === false);
}

// primary che dipende dalla presenza del valore
//export function primaryByFieldValue(items: any[], allColumnsDef: EstensaColDef[], formType: SearchFormType) {
//    const showColDose = items.some((el) => el.hasDose);
//    const showColSendToWorklist = items.some((el) => el.command.mustBeManualSentToWorklist);
//    const showColAiScore = items.some((el) => el.aiData.scoreValue);
//    allColumnsDef.map((col: EstensaColDef) => {
//        if (col.colId === 'Doses') {
//            showColDose ? col.estensaDetails.primary = false : col.estensaDetails.primary = true;
//        }
//        if (col.colId === 'SendToWorklist') {
//            showColSendToWorklist ? col.estensaDetails.primary = true : col.estensaDetails.primary = false;
//        }
//        if (col.colId === 'AiScore') {
//            showColAiScore ? col.estensaDetails.primary = true : col.estensaDetails.primary = false;
//        }
//    });
//}
